/**
 * Created by stonewang on 2017/9/6.
 */
import React from 'react'
import PropTypes from 'prop-types';
import { Cascader } from 'antd';
import {listByParentId} from '../service/region'
const options = [
  {
    "regionName": "北京市",
    "parentRegionId": 1,
    "regionId": 2,
    "level": 1,
    "isLeaf": false, //如果要使用loadData功能则必须要有这个字段
    "value": 2,
    "label": "北京市"
  }, {
    "regionName": "天津市",
    "parentRegionId": 1,
    "regionId": 3,
    "level": 1, "isLeaf":false,
    "value": 3,
    "label": "天津市"
  }, {
    "regionName": "河北省",
    "parentRegionId": 1,
    "regionId": 4,
    "level": 1, "isLeaf":false,
    "value": 4,
    "label": "河北省"
  }, {
    "regionName": "山西省",
    "parentRegionId": 1,
    "regionId": 5,
    "level": 1, "isLeaf":false,
    "value": 5,
    "label": "山西省"
  }, {
    "regionName": "内蒙古自治区",
    "parentRegionId": 1,
    "regionId": 6,
    "level": 1, "isLeaf":false,
    "value": 6,
    "label": "内蒙古自治区"
  }, {
    "regionName": "辽宁省",
    "parentRegionId": 1,
    "regionId": 7,
    "level": 1, "isLeaf":false,
    "value": 7,
    "label": "辽宁省"
  }, {
    "regionName": "吉林省",
    "parentRegionId": 1,
    "regionId": 8,
    "level": 1, "isLeaf":false,
    "value": 8,
    "label": "吉林省"
  }, {
    "regionName": "黑龙江省",
    "parentRegionId": 1,
    "regionId": 9,
    "level": 1, "isLeaf":false,
    "value": 9,
    "label": "黑龙江省"
  }, {
    "regionName": "上海市",
    "parentRegionId": 1,
    "regionId": 10,
    "level": 1, "isLeaf":false,
    "value": 10,
    "label": "上海市"
  }, {
    "regionName": "江苏省",
    "parentRegionId": 1,
    "regionId": 11,
    "level": 1, "isLeaf":false,
    "value": 11,
    "label": "江苏省"
  }, {
    "regionName": "浙江省",
    "parentRegionId": 1,
    "regionId": 12,
    "level": 1, "isLeaf":false,
    "value": 12,
    "label": "浙江省"
  }, {
    "regionName": "安徽省",
    "parentRegionId": 1,
    "regionId": 13,
    "level": 1, "isLeaf":false,
    "value": 13,
    "label": "安徽省"
  }, {
    "regionName": "福建省",
    "parentRegionId": 1,
    "regionId": 14,
    "level": 1, "isLeaf":false,
    "value": 14,
    "label": "福建省"
  }, {
    "regionName": "江西省",
    "parentRegionId": 1,
    "regionId": 15,
    "level": 1, "isLeaf":false,
    "value": 15,
    "label": "江西省"
  }, {
    "regionName": "山东省",
    "parentRegionId": 1,
    "regionId": 16,
    "level": 1, "isLeaf":false,
    "value": 16,
    "label": "山东省"
  }, {
    "regionName": "河南省",
    "parentRegionId": 1,
    "regionId": 17,
    "level": 1, "isLeaf":false,
    "value": 17,
    "label": "河南省"
  }, {
    "regionName": "湖北省",
    "parentRegionId": 1,
    "regionId": 18,
    "level": 1, "isLeaf":false,
    "value": 18,
    "label": "湖北省"
  }, {
    "regionName": "湖南省",
    "parentRegionId": 1,
    "regionId": 19,
    "level": 1, "isLeaf":false,
    "value": 19,
    "label": "湖南省"
  }, {
    "regionName": "广东省",
    "parentRegionId": 1,
    "regionId": 20,
    "level": 1, "isLeaf":false,
    "value": 20,
    "label": "广东省"
  }, {
    "regionName": "广西壮族自治区",
    "parentRegionId": 1,
    "regionId": 21,
    "level": 1, "isLeaf":false,
    "value": 21,
    "label": "广西壮族自治区"
  }, {
    "regionName": "海南省",
    "parentRegionId": 1,
    "regionId": 22,
    "level": 1, "isLeaf":false,
    "value": 22,
    "label": "海南省"
  }, {
    "regionName": "重庆市",
    "parentRegionId": 1,
    "regionId": 23,
    "level": 1, "isLeaf":false,
    "value": 23,
    "label": "重庆市"
  }, {
    "regionName": "四川省",
    "parentRegionId": 1,
    "regionId": 24,
    "level": 1, "isLeaf":false,
    "value": 24,
    "label": "四川省"
  }, {
    "regionName": "贵州省",
    "parentRegionId": 1,
    "regionId": 25,
    "level": 1, "isLeaf":false,
    "value": 25,
    "label": "贵州省"
  }, {
    "regionName": "云南省",
    "parentRegionId": 1,
    "regionId": 26,
    "level": 1, "isLeaf":false,
    "value": 26,
    "label": "云南省"
  }, {
    "regionName": "西藏自治区",
    "parentRegionId": 1,
    "regionId": 27,
    "level": 1, "isLeaf":false,
    "value": 27,
    "label": "西藏自治区"
  }, {
    "regionName": "陕西省",
    "parentRegionId": 1,
    "regionId": 28,
    "level": 1, "isLeaf":false,
    "value": 28,
    "label": "陕西省"
  }, {
    "regionName": "甘肃省",
    "parentRegionId": 1,
    "regionId": 29,
    "level": 1, "isLeaf":false,
    "value": 29,
    "label": "甘肃省"
  }, {
    "regionName": "青海省",
    "parentRegionId": 1,
    "regionId": 30,
    "level": 1, "isLeaf":false,
    "value": 30,
    "label": "青海省"
  }, {
    "regionName": "宁夏回族自治区",
    "parentRegionId": 1,
    "regionId": 31,
    "level": 1, "isLeaf":false,
    "value": 31,
    "label": "宁夏回族自治区"
  },
  { "regionName": "新疆维吾尔自治区", "parentRegionId": 1, "regionId": 32, "level": 1, "isLeaf":false, "value": 32, "label": "新疆维吾尔自治区" }
];
class RegionCascader extends React.Component {
  constructor (props) {
    super(props);
    const value = this.props.value || {};
    let arr = null;
    /*if(!value.province && !value.city && !value.county){
      arr = [];
    }*/
    if(value.province && !value.city && !value.county){
      arr = [value.province];
    }
    if(value.province && value.city && !value.county){
      arr = [value.province, value.city];
    }
    if(value.province && value.city && value.county){
      arr = [value.province, value.city, value.county];
    }
    this.mounted = false;
    this.state = {
      options,
      oldProps: arr ? value : {},
      value: arr,
    }
    this.onChangeRC = this.onChangeRC.bind(this);
    this.loadDataRC = this.loadDataRC.bind(this);
    this.getInitValue = this.getInitValue.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    // Should be a controlled component.
    if ('value' in nextProps && nextProps.value) {
      const value = nextProps.value;
      const oldKeys = Object.keys(this.state.oldProps);
      const newkeys = Object.keys(value);
      if(oldKeys.join() !== newkeys.join()){

        let arr = null;
        if(value.province && !value.city && !value.county){
          arr = [value.province];
        }
        if(value.province && value.city && !value.county){
          arr = [value.province, value.city];
        }
        if(value.province && value.city && value.county){
          arr = [value.province, value.city, value.county];
        }
        if(arr && arr.length>0 && this.mounted){
          this.setState({value: arr, oldProps:value}, ()=>{
            this.getInitValue()
          });
        }
      }
    }
  }
  componentDidMount() {
    this.mounted = true;
    if(this.state.value){
      this.getInitValue()
    }
  }

  getInitValue(){
    const {value, options} = this.state;
    if(value && value.length>0){
      const provinceIndex = options.findIndex(item => item.regionId === value[0]);
      this.loadDataRC([options[provinceIndex]], ()=>{
        let province = options[provinceIndex];
        if(value[1]){
          const cityIndex = province.children.findIndex(item => item.regionId === value[1]);

          this.loadDataRC([options[provinceIndex], province.children[cityIndex]]);
        }
      })
    }
  }

  onChangeRC (value, selectedOptions) {
    this.setState({value});
    const onChange = this.props.onChange;
    if (onChange) {
      let tmp = {}
      selectedOptions.forEach((item, index) => {
        index===0 && (tmp.province = item.regionId);
        index===1 && (tmp.city = item.regionId);
        index===2 && (tmp.county = item.regionId);
      });
      if(value.length>0){
        onChange({value: tmp, selectedOptions});
      }else{
        onChange(null);
      }
    }

    if (this.props.handle) {
      this.props.handle(value, selectedOptions);
    }
  }
  loadDataRC(selectedOptions, callback) {
    const self = this;
    const targetOption = selectedOptions[selectedOptions.length - 1];
    const parentId = targetOption.regionId;
    targetOption.loading = true;

    if(targetOption.level === 3) return null;
    if(targetOption.children && targetOption.children.length>0) return null;

    listByParentId(parentId).then(res => {
      targetOption.loading = false;

      let opts = res.data.map(item => {
        return {
          ...item,
          value: item.regionId,
          label: item.regionName,
          level: targetOption.level === 1 ? 2 : (targetOption.level === 2 ? 3 : ''), //层级
          isLeaf: targetOption.level === 1 ? false : true, //如果要使用loadData功能则必须要有这个字段
        }
      });

      if(targetOption.level === 1 || targetOption.level === 2){
        targetOption.children = opts;
      }

      if(callback && typeof callback === 'function'){
        self.setState({
          options: [...this.state.options],
        }, ()=>{
          callback();
        });
      }else{
        self.setState({
          options: [...this.state.options],
        });
      }
    })
  }
  render () {
    const { containerId, disabled, style, placeholder } = this.props;
    return <Cascader
      style={style}
      size="large"
      value={this.state.value}
      options={this.state.options}
      onChange={this.onChangeRC}
      loadData={this.loadDataRC.bind(this)}
      changeOnSelect
      placeholder={placeholder || "请选择所在地区"}
      getPopupContainer={() => containerId ? document.getElementById(containerId) : document.body}
      disabled={disabled}
    />
  }
}

RegionCascader.propTypes = {
  style: PropTypes.object,
  value: PropTypes.object,
  disabled: PropTypes.bool,
  containerId: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  handle: PropTypes.func,
};
export default RegionCascader


// WEBPACK FOOTER //
// ./src/components/regionCascader.js